"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStore = exports.LocalStore = void 0;
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const lodash_pick_1 = __importDefault(require("lodash.pick"));
const vuex_1 = require("vuex");
/**
 * Custom store that saves the state to LocalStorage when there is a change.
 */
class LocalStore extends vuex_1.Store {
    constructor(options) {
        super(options);
        this.cacheKey = options.cacheKey;
        this.cachePaths = options.cachePaths;
        this.replaceState((0, lodash_merge_1.default)(this.state, this.load()));
        this.subscribe((_, state) => this.save(state));
    }
    load() {
        try {
            const cache = localStorage.getItem(this.cacheKey);
            return !!cache ? JSON.parse(cache) : {};
        }
        catch (e) {
            console.warn(e);
            return {};
        }
    }
    save(state) {
        try {
            const cache = (0, lodash_pick_1.default)(state, this.cachePaths);
            localStorage.setItem(this.cacheKey, JSON.stringify(cache));
        }
        catch (e) {
            console.warn(e);
        }
    }
}
exports.LocalStore = LocalStore;
/**
 * Creates a new instance of LocalStore.
 *
 * @param options - The options used to create the new instance.
 * @returns - The LocalStore instance.
 */
function createStore(options) {
    return new LocalStore(options);
}
exports.createStore = createStore;
